<script>
import Layout from '@layouts/default'
import VehicleSearch from '@components/vehicle-search'

export default {
  page: {
    title: 'Car Odometer Rollback Fraud | AutoCheck | AutoCheck.com',
    meta: [
      {
        name: 'description',
        content:
          "Learn how to protect yourself from car odometer rollback fraud. Don't pay more for a vehicle than it's worth by becoming a victim of this common crime.",
      },
      {
        name: 'keywords',
        content: 'car odometer rollback fraud',
      },
    ],
    link: [
      {
        rel: 'canonical',
        href: 'https://www.autocheck.com/vehiclehistory/odometer-fraud',
      },
    ],
  },
  components: { Layout, VehicleSearch },
  methods: {
    showModal() {
      this.$refs.myModalRef.show()
    },
  },
}
</script>

<template>
  <Layout>
    <div class="row mt-4">
      <div class="col-12 col-md-9">
        <h1
          >Protect Yourself from <br />
          Odometer Fraud</h1
        >
        <hr />
        <div class="sectionContent">
          <h3 class="titleBlue">What is odometer fraud?</h3>
          <p
            >Because low mileage is an attractive quality in a used vehicle,
            sometimes sellers tamper with the odometer to give the illusion that
            the vehicle was driven less than it actually was by “clocking” or
            rolling back the miles.</p
          >
        </div>
        <div class="sectionContent">
          <h4 class="titleBlue">Protect against odometer fraud: </h4>
          <ol>
            <li style="list-style: decimal outside; margin-bottom: 10px;"
              >Compare mileage on the vehicle with the title.&nbsp; Also ask the
              seller for maintenance records or emission test records.</li
            >
            <li style="list-style: decimal outside;margin-bottom: 10px;"
              >Check the AutoCheck<sup>®</sup> report to confirm the current
              mileage on the vehicle aligns to the previously reported
              mileage.</li
            >
            <li style="list-style: decimal outside;"
              >Take the vehicle to a mechanic for a thorough inspection.</li
            >
          </ol>
          <p>&nbsp;</p>
          <p
            ><img
              width="100%"
              vspace="0"
              hspace="0"
              height="238"
              border="0"
              align="middle"
              src=" images/odometer.jpg"
              alt="Odometer Graphic"
          /></p>
          <h3 class="titleBlue">How AutoCheck helps?</h3>
          <p
            >In an AutoCheck report data sources are thoroughly reviewed and
            odometer readings are arranged in chronological order to ensure
            there are no potential mileage discrepancies. The odometer check
            then summarizes the data and alerts you to any potential red
            flags.</p
          >
          <p>
            <span
              class="clickLink"
              :class="$style.forgotLink"
              @click="showModal"
            >
              See samples of vehicle history reports that have odometer fraud »
            </span>
          </p>
          <b-modal
            ref="myModalRef"
            hide-footer
            centered
            title="Samples of vehicle history reports that have odometer fraud"
          >
            <div class="d-block">
              <img
                src="images/accident-odometer-expand.jpg"
                style="width: 650px; max-width: 100%;"
              />
            </div>
          </b-modal>
        </div>
        <div class="sectionContent">
          <h3 class="titleBlue">What if you are a victim of fraud?</h3>
          <p
            >Tough laws are in place to punish the perpetrator and legal action
            may be necessary. Notify a consumer protection agency like
            <BaseLink :to="{ name: 'call-for-action' }"
              >Call For Action</BaseLink
            >
            immediately to get the professional help and advise you need.</p
          >
          <p>&nbsp;</p>
        </div>
        <VehicleSearch />
      </div>
      <div class="col-12 col-md-3">
        <div class="mt-4">
          <a v-scroll-to="'#searchVin'" href="#"
            ><img class="w-80 m-auto d-block" src="images/ac-check-vin.png"
          /></a>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';
</style>
